import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FileViewer from '../../components/FileViewer';
import { LineLoader } from '@timmons-group/shared-react-components';
import { useGet } from '@timmons-group/shared-react-components/hooks';

const ActivityAttachments = ({ id }) => {
  // State to store files - nulls appear as loading spinners
  const [fileData, setFileData] = useState([]);
  const [fileInfo, setFileInfo] = useState([]);
  const [attachments, loading] = useGet(`/api/activity/get/attachments?id=${id}`, [])

  const processData = async (data) => {
    // Unpack attachment data
    const attachments = data?.attachments || [];

    // Map attachments to fileData - Actual Blob data (unused for now - reverted to URL) for downloading
    const fileDataTemp = attachments.map((attachment) => {
      const { id, data, url, name } = attachment;
      return { id, data, name, url };
    });

    // Map attachments to fileInfo - just metadata about the files for use in FileViewer
    const fileInfoTemp = await Promise.all(attachments.map(async (attachment) => {
      const { id, name, data_size, url } = attachment;
      return {
        id,
        name,
        thumbnailUrl: url
      };
    }));

    // Update state
    setFileData(fileDataTemp);
    setFileInfo(fileInfoTemp);
  };

  // Handle download requests - passed to FileViewer as a handler function
  const handleDownloadRequest = async (ids) => {
    console.log('Data DL request', ids);

    // Get the assocaited fileData with matching ids
    const files = fileData.filter((file) => ids.includes(file.id));

    // Download multiple files
    files.forEach((file) => {
      // Create an invisible anchor tag
      const link = document.createElement('a');
      link.href = file.url;
      link.download = file.name;
      link.target = '_blank';
      link.click();
    });

  };

  // useEffect to make a get request to test endpoint when component first loads
  useEffect(() => {
    if (!loading) processData(attachments);
  }, [attachments, loading]);

  // 🌍 Main render
  return (
    <>
      {!loading && <FileViewer
        files={fileInfo}
        onDownloadRequest={handleDownloadRequest}
      />}
      {loading && <LineLoader color="primary" message="Loading Attachments..." />}
    </>
  );
}

ActivityAttachments.propTypes = {
  id: PropTypes.number,
};

export default ActivityAttachments;
